import React from 'react';
import { TrainingCoursesHeroStyles as S } from './TrainingCoursesHero.styles';
import { imageUrl } from '@helpers/imageUrl';
import { ReactComponent as ClockIcon } from '@img/icons/clock.svg';
import { ReactComponent as CamcorderIcon } from '@img/icons/camcorder.svg';
import { ReactComponent as UserGroupIcon } from '@img/icons/user-group.svg';
import Breadcrumbs from '@stories/Widgets/Meta/Breadcrumbs/Breadcrumbs.widget';
import withWidget from '@hoc/withWidget';
import { HydrateOption } from '@core/enums';
const TrainingCoursesHero = (props) => {
    return (React.createElement(S.Container, null,
        props.breadcrumbItems && props.breadcrumbItems.length > 0 && (React.createElement(S.BreadcrumbsWrapper, null,
            React.createElement(S.GridOverride, null,
                React.createElement(Breadcrumbs, { items: props.breadcrumbItems })))),
        props.image && props.image.src && (React.createElement(React.Fragment, null,
            React.createElement(S.BackgroundImage, { loading: "eager", src: imageUrl(props.image.src, { width: 375, dpr: 2 }), srcSet: [
                    `${imageUrl(props.image.src, { width: 1024, dpr: 1 })} 1024w`,
                    `${imageUrl(props.image.src, { width: 1920, dpr: 1 })} 1600w`,
                ].join(','), alt: props.image.alt ? props.image.alt : '', width: 375 }),
            React.createElement(S.BackgroundOverlayTint, null))),
        React.createElement(S.GridOverride, null,
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.InnerContent, null,
                    props.title && React.createElement(S.Heading, null, props.title),
                    props.courseDetails && (React.createElement(S.CourseDetails, null,
                        props.courseDetails?.duration && (React.createElement(S.CourseDetail, null,
                            React.createElement(ClockIcon, null),
                            props.courseDetails?.duration)),
                        props.courseDetails?.numOfAttendees && (React.createElement(S.CourseDetail, null,
                            React.createElement(UserGroupIcon, null),
                            props.courseDetails?.numOfAttendees)),
                        props.courseDetails?.availableOnline && (React.createElement(S.CourseDetail, null,
                            React.createElement(CamcorderIcon, null),
                            props.courseDetails?.availableOnline)))),
                    props.introText && React.createElement(S.Paragraph, null, props.introText),
                    props.bookNowButton && props.bookNowButton.href && props.bookNowButton.title && (React.createElement(S.Button, { branding: "secondary", hoverColour: "primary", title: props.bookNowButton.title, href: props.bookNowButton.href })))))));
};
export default withWidget(TrainingCoursesHero, 'TrainingCoursesHero', {
    hydrate: HydrateOption.InView,
});
